import { Card, Col, Divider, Form, Row } from 'antd';
import NumberInput from 'app/components/NumberInput/NumberInput';
import { selectSelectedFieldsByCompany } from 'app/containers/Map/slice/selectors';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TextRegular12, TextRegular14 } from 'styles/typography';
import { checkIsPositiveNumber } from 'utils/validationHelpers';
import CompanyCultureFieldsList from '../CompanyCultureFieldsList/CompanyCultureFieldsList';

interface IProps {}

const CreateOrEditCompaniesList: FC<IProps> = () => {
  const { t } = useTranslation();

  const sortedFields = useSelector(selectSelectedFieldsByCompany);

  return (
    <>
      {sortedFields.map(company => {
        return (
          <React.Fragment key={company.companyId}>
            <Card
              key={company.companyId}
              bordered={false}
              title={company.companyName}
              style={{ marginTop: '12px' }}
            >
              <Row>
                <Col span={12}>
                  <TextRegular14>
                    {t('Cultures.CreateCulture.CulturalArea', 'Cultural area')}
                  </TextRegular14>
                </Col>

                <Col span={12}>
                  <TextRegular12>{company.area}</TextRegular12>
                </Col>
              </Row>
              <Divider dashed />

              <Row>
                <Col span={12}>
                  <TextRegular14 style={{ verticalAlign: 'sub' }}>
                    {t('Cultures.CreateCulture.HarvestPlan', 'Harvest plan')}
                  </TextRegular14>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name={company.companyId}
                    rules={[
                      { required: true },
                      { validator: checkIsPositiveNumber },
                    ]}
                  >
                    <NumberInput
                      placeholder={t(
                        'Cultures.CreateCulture.Insert',
                        'Insert t/Ha',
                      )}
                      style={{ width: '100%', fontSize: 12 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <CompanyCultureFieldsList mappedFieldParams={company.fieldParams} />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CreateOrEditCompaniesList;
